import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

const SITE_PIN_COLORS = [
  'var(--ds-color-green-50)',
  'var(--ds-color-blue-50)',
  'var(--ds-color-purple-50)',
  'var(--ds-color-teal-50)',
  'var(--ds-color-orange-50)',
  'var(--ds-color-pink-50)',
  'var(--ds-color-indigo-50)',
  'var(--ds-color-cyan-50)',
  'var(--ds-color-violet-50)',
  'var(--ds-color-red-50)',
];

/** Map-style thumbnail with a colored pin, cycled per `index` so adjacent
    construction-site rows are visually distinguishable. Size and corner radius
    are driven by the host element's CSS. */
@Component({
  selector: 'soft-site-map-thumb',
  templateUrl: './site-map-thumb.component.html',
  styleUrls: ['./site-map-thumb.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.--pin]': 'pinColor()' },
})
export class SiteMapThumbComponent {
  readonly index = input<number>(0);

  protected readonly pinColor = computed(
    () => SITE_PIN_COLORS[this.index() % SITE_PIN_COLORS.length]
  );
}
